import React from 'react';
import { Link } from 'react-router-dom';

import { Link as MuiLink, Typography } from '@mui/material';

interface Props {
    value: string;
    label: string;
    to: string;
    className?: string;
    active?: string;
}

const SortLink: React.FC<Props> = ({ label, active, value, to, className }) => {
    return value === active ? (
        <Typography sx={{ cursor: 'default' }} component="span" variant="body2" fontWeight="bold" className={className}>
            {label}
        </Typography>
    ) : (
        <MuiLink to={to} replace component={Link} variant="body2" underline="none" className={className}>
            {label}
        </MuiLink>
    );
};

export default SortLink;
